import Base from "@/controllers/base";
export default class Appointment extends Base {
  constructor(elem) {
    super(elem);
  }

  delayByTrucker(event) {
    const total = parseFloat(document.querySelector(".total-moves").innerHTML);
    const lates = document.querySelectorAll(".delay-by-trucker:checked").length;
    const ratio = ((lates / total) * 100).toFixed(2) + "%";
    const totalLatesElem = document.querySelector(".total-lates");
    const lateRatioElem = document.querySelector(".late-ratio");
    totalLatesElem.innerHTML = lates;
    totalLatesElem.highlight("yellow", 3000);
    lateRatioElem.innerHTML = ratio;
    lateRatioElem.highlight("yellow", 3000);
  }
}
